import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

import { InputProps } from "../types/types";

const Input = ({
  input,
  setInput,
  sendMessage,
  isLoading,
  maxLength,
}: InputProps) => {
  const [message, setMessage] = useState("");

  const sendBtnDisabled = !input.trim() || isLoading;

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    if (maxLength && newValue.length === maxLength) {
      setMessage(`You've reached the maximum of ${maxLength} characters.`);
    } else {
      setMessage("");
    }

    setInput(newValue);
  };

  return (
    <div className="input-section">
      {/* Loader */}
      {isLoading && (
        <div className="loader">
          Thinking
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M5.41675 15.8334C3.34568 15.8334 1.66675 14.1545 1.66675 12.0834C1.66675 10.1304 3.15967 8.52616 5.06653 8.34956C5.45659 5.97686 7.51695 4.16675 10.0001 4.16675C12.4832 4.16675 14.5436 5.97686 14.9336 8.34956C16.8405 8.52616 18.3334 10.1304 18.3334 12.0834C18.3334 14.1545 16.6545 15.8334 14.5834 15.8334C10.9252 15.8334 8.6195 15.8334 5.41675 15.8334Z"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      )}

      <div className="flex-input-section-blk">
        <input
          className="input-chat"
          disabled={isLoading}
          value={input}
          onChange={handleInputChange}
          onKeyDown={(e) => e.key === "Enter" && sendMessage()}
          placeholder="Type here"
          maxLength={maxLength}
        />

        <button
          onClick={sendMessage}
          disabled={isLoading}
          style={{
            cursor: sendBtnDisabled ? "default" : "pointer",
            color: sendBtnDisabled ? "rgba(255, 255, 255, 0.20)" : "white",
          }}
          className="send-button"
        >
          <FontAwesomeIcon icon={faPaperPlane} />
        </button>
      </div>

      {message && (
        <div className={`tooltip ${message ? "show" : ""}`}>{message}</div>
      )}
    </div>
  );
};

export default Input;
